import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

// Helper to check valid email
function checkIsValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Chips Input Component
 */
export default function ChipsInput({
  initialChips = [],
  handleChange = () => {},
  className = "",
  placeholder = "Type and press enter...",
  chipsAsEmail = false,
}) {
  const [chips, setChips] = useState([]);
  const [input, setInput] = useState("");

  // update state
  useEffect(() => {
    setChips(initialChips);
  }, [initialChips.length]);

  function handleKeyDown(e) {
    const trimmedInput = input.trim();
    const isValidEmail = checkIsValidEmail(trimmedInput);

    if ((e.key === "Enter" || e.key === ",") && trimmedInput) {
      e.preventDefault();

      // email check
      if (chipsAsEmail && !isValidEmail) {
        toast.error("Enter Valid Email");
        return;
      }

      if (!chips.includes(trimmedInput)) {
        const finalChips = [...chips, trimmedInput];
        setChips(finalChips);
        handleChange(finalChips);
      }
      setInput("");
    } else if (e.key === "Backspace" && !input && chips.length) {
      const finalChips = chips.slice(0, -1);
      setChips(finalChips);
      handleChange(finalChips);
    }
  }

  function removeChip(chipToRemove) {
    const finalChips = chips.filter((chip) => chip !== chipToRemove);
    setChips(finalChips);
    handleChange(finalChips);
  }

  // style
  const containerPadding = chips.length > 0 ? "p-2" : "px-2";

  return (
    <div
      className={`d-flex flex-wrap border-form align-items-center rounded-lg ${containerPadding} ${className}`}
    >
      {chips.map((chip, index) => (
        <div
          key={index}
          className="px-2 py-1 mb-2 mr-2 border rounded-xl d-flex align-items-center"
        >
          {chip}
          <span
            className="ml-2 cursor-pointer font-weight-bold"
            onClick={() => removeChip(chip)}
          >
            ×
          </span>
        </div>
      ))}
      <input
        type="text"
        className="form-control border-0 rounded-lg shadow-none p-1"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
    </div>
  );
}
